import { FC } from 'react';
import cn from 'classnames';
import type { NodeToRenderProps, CustomNodeData } from './types/custom-nodes.type';
import { applyPlaceholderHocs } from '../../scenario-editor/utils';

export const NodeToRender: FC<NodeToRenderProps>  = ({ className, selected, ...props }) => {
  return (
    <div
      className={
        cn([
          "flex rounded-md p-2 justify-center items-center border-none",
          className
        ])
      }
      style={props.style}
      data-testid="node=>placeholder"
    >
      <div
        className={cn(['p-1 bg-blue-200 rounded-xl flex justify-center transition-all duration-100 ease-out', { '!w-full': selected }])}
      >
        <div className={cn(['h-3 w-3 bg-blue-600 rounded-md transition-all duration-100 ease-out', { '!w-full': selected, '!h-1.5': selected }])}></div>
      </div>
    </div>
  )
};

const NodeItem = applyPlaceholderHocs(NodeToRender);

export const PlaceholderNode = (props: NodeToRenderProps) => {
  return (
    <>
      <NodeItem {...props}>{(props.data as CustomNodeData).title}</NodeItem>
    </>
  );
};
